// ================================
// 3. frontend/src/admin/pages/SystemMonitoring.js
// ================================
import React from 'react';

const SystemMonitoring = ({ adminUser, onPageChange }) => {
  React.useEffect(() => {
    onPageChange?.('monitoring');
  }, [onPageChange]);

  return (
    <div style={{
      background: '#0f172a',
      color: 'white',
      minHeight: 'calc(100vh - 64px)',
      padding: '2rem'
    }}>
      <div style={{
        background: '#1e293b',
        borderRadius: '1rem',
        padding: '2rem',
        textAlign: 'center'
      }}>
        <h1>🚨 Monitoring Système</h1>
        <p style={{ color: '#94a3b8', marginBottom: '2rem' }}>
          Surveillance de la santé du système et gestion des alertes
        </p>
        
        <div style={{
          background: '#334155',
          padding: '1.5rem',
          borderRadius: '0.75rem',
          margin: '1rem 0'
        }}>
          <h3>🚧 Fonctionnalités à venir :</h3>
          <ul style={{ textAlign: 'left', color: '#cbd5e1' }}>
            <li>🖥️ Santé serveur (CPU, RAM, Disque)</li>
            <li>📊 Monitoring base de données</li>
            <li>🚨 Système d'alertes temps réel</li>
            <li>📝 Logs système centralisés</li>
            <li>⚡ Tests de santé automatiques</li>
          </ul>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '1rem',
          margin: '1.5rem 0'
        }}>
          <div style={{
            background: '#334155',
            padding: '1rem',
            borderRadius: '0.5rem',
            borderLeft: '4px solid #10b981'
          }}>
            <div style={{ fontSize: '1.5rem' }}>🟢</div>
            <div style={{ fontWeight: '600' }}>Serveur</div>
            <div style={{ fontSize: '0.875rem', color: '#94a3b8' }}>Opérationnel</div>
          </div>
          
          <div style={{
            background: '#334155',
            padding: '1rem',
            borderRadius: '0.5rem',
            borderLeft: '4px solid #10b981'
          }}>
            <div style={{ fontSize: '1.5rem' }}>🟢</div>
            <div style={{ fontWeight: '600' }}>Base de Données</div>
            <div style={{ fontSize: '0.875rem', color: '#94a3b8' }}>Connectée</div>
          </div>
          
          <div style={{
            background: '#334155',
            padding: '1rem',
            borderRadius: '0.5rem',
            borderLeft: '4px solid #10b981'
          }}>
            <div style={{ fontSize: '1.5rem' }}>🟢</div>
            <div style={{ fontWeight: '600' }}>APIs</div>
            <div style={{ fontSize: '0.875rem', color: '#94a3b8' }}>Fonctionnelles</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SystemMonitoring;